import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { AdminComponent } from "./admin/admin.component";
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, AdminComponent,CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'SafeScan';
  showLayout: boolean = true;
  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      this.checkRoute();
    });
  }
  checkRoute() {
    const hiddenRoutes = ['/login','/unauthorized'];
    this.showLayout = !hiddenRoutes.includes(this.router.url);
  }
}